import { CATEGORIES } from './constants';

const { PERFORMANCE, TOPIC_IN_FOCUS, TAKE_ACTION, ABOUT, REPORT, BACKGROUND, APPENDIX } = CATEGORIES;

export const TRANSPARENT = 'transparent';
export const WHITE = '#FFF';
export const BLACK = '#000';
export const DUSTY_GRAY = '#999';
export const MAGIC_MINT = '#8bedac';
export const BUTTERFLY_BUSH = '#4d549c';
export const HALF_BAKED = '#91bcd6';

export const MODAL_BLUE = '#2571BA';

export const MODAL = {
  BACKGROUND_COLOR: 'rgba(0, 0, 0, 0.4)',
  BUTTON_CLOSE_COLOR: 'rgb(15 19 21 / 20%)',
};

export const BRAND_COLORS = ['#BCE2C8', '#4FBBD2', '#2571BA', '#1A2380'];

export const UI_COLORS = ['#0F1315', '#2B363D', '#456673', '#6E8892', '#A0B3B8', '#D3E0DF', '#E5E7ED', '#F2F3F6'];

export const CATEGORICAL_COLORS = ['#36A489', '#3A5AC5', '#C05EF3', '#4FBBD2'];

export const CATEGORIES_COLOR = {
  [PERFORMANCE]: CATEGORICAL_COLORS[0],
  [TOPIC_IN_FOCUS]: CATEGORICAL_COLORS[1],
  [REPORT]: CATEGORICAL_COLORS[1],
  [TAKE_ACTION]: CATEGORICAL_COLORS[2],
  [BACKGROUND]: CATEGORICAL_COLORS[3],
  [ABOUT]: CATEGORICAL_COLORS[3],
  [APPENDIX]: CATEGORICAL_COLORS[3]
};

export const CHART_PALETTE = [
  // 2020 colors
  // '#1B64A9',
  // '#528EC8',
  // '#8FD4E2',
  // '#A9FAE7',
  // '#6FBDA9',
  // '#019996',
  // '#E1BBF5',
  // '#C05EF3',
  // '#EC6666',
  // 2022 colors
  '#019996',
  '#8FD4E2',
  '#4FBBD2',
  '#E1BBF5',
  '#33c8a5',
  '#1B64A9',
  '#528EC8',
  '#C05EF3',
  '#EC6666'
];

export const BAR_CHART_PALETTE_LIGHT = [...CHART_PALETTE, '#2571BACC', '#72c9dbCC', '#95f9e1CC', '#d9a9f2CC'];
export const PIE_CHART_PALETTE_LIGHT = [...CHART_PALETTE, '#677ffb', '#1ec5e9', '#42f4ca', '#d094ef', '#d3e0df'];
export const CHART_PALETTE_DARK = [...CHART_PALETTE, '#32f5c9', '#017f8f'];
export const SCORE_PALETTE = [...BRAND_COLORS].reverse();

export const GREEN_COLORS_SET = {
  color: CATEGORICAL_COLORS[0],
  background: '#eaf4f3',
  line: CATEGORICAL_COLORS[0],
  link: CATEGORICAL_COLORS[0],
};

export const BLUE_COLORS_SET = {
  color: CATEGORICAL_COLORS[1],
  background: '#2571ba14',
  line: CATEGORICAL_COLORS[1],
  link: CATEGORICAL_COLORS[1],
};

export const RED_COLORS_SET = {
  color: CATEGORICAL_COLORS[2],
  background: '#e1bbf533',
  line: CATEGORICAL_COLORS[2],
  link: CATEGORICAL_COLORS[2],
};

export const TEAL_COLORS_SET = {
  color: CATEGORICAL_COLORS[3],
  background: '#4FBBD21A',
  line: CATEGORICAL_COLORS[3],
  link: CATEGORICAL_COLORS[3]
}

export const COLORS_SETS = {
  [ABOUT]: TEAL_COLORS_SET,
  [BACKGROUND]: TEAL_COLORS_SET,
  [PERFORMANCE]: GREEN_COLORS_SET,
  [REPORT]: BLUE_COLORS_SET,
  [TOPIC_IN_FOCUS]: BLUE_COLORS_SET,
  [TAKE_ACTION]: RED_COLORS_SET,
  [APPENDIX]: TEAL_COLORS_SET
};

const GRAY = '#9a9a9a';

export const CHART_BACKGROUND_COLOR = '#f8f8f8';
export const CHART_TITLE_COLOR = UI_COLORS[2];
export const CHART_SUBTITLE_COLOR = '#ababab';
export const CHART_AXIS_TICK_COLOR = GRAY;
export const CHART_AXIS_LABEL_COLOR = GRAY;
export const CHART_AXIS_LIGHT_LABEL_COLOR = '#b3b2b3';
export const CHART_LABEL_COLOR = GRAY;
export const CHART_RADIAL_GRID_COLOR = '#eaeaea';
export const CHART_DEFAULT_SERIE_COLOR = '#555';
export const CHART_SPIDER_WEB = '#eaeaea';
export const CHART_BOX_LABEL_COLOR = '#aaa';
export const CHART_BOX_GRID_COLOR = '#e8e8e8';

export const TOOLTIP_SHADOW_COLOR = 'rgba(33, 33, 33, 0.2)';
export const TOOLTIP_CONTENT_COLOR = '#000000CC';

export const HOMEPAGE_BACKGROUND_COLOR = UI_COLORS[7];
export const HOMEPAGE_MAIN_TITLE_COLOR = BRAND_COLORS[2];
export const HOMEPAGE_SECTION_JUMPER_COLOR = '#36a489';
export const HOMEPAGE_TEXT_COLOR = UI_COLORS[2];

export const FOOTER_BACKGROUND_COLOR = UI_COLORS[2];
export const FOOTER_TEXT_COLOR = WHITE;

export const SIDEBAR_TITLE_COLOR = BRAND_COLORS[2];
export const SIDEBAR_LINE_COLOR = UI_COLORS[7];
export const SIDEBAR_TEXT_COLOR = UI_COLORS[2];
export const SIDEBAR_DOT_TEXT_COLOR = WHITE;

export const CARD_SHADOW_COLOR = '#cfcfcf';

export const HERO_LINE_COLOR = UI_COLORS[7];

export const WIDE_CHART_BACKGROUND_COLOR = UI_COLORS[7];

export const CHART_CAROUSEL_TITLE_COLOR = UI_COLORS[2];
export const CHART_CAROUSEL_TAB_COLOR = UI_COLORS[2];

export const IMAGE_TITLE_COLOR = UI_COLORS[2];

export const MAP_BACKGROUND_COLOR = '#f8f8f8';

export const THEME_COLORS = {
  VERY_LIGHT_PINK: '#efefef',
  GREYISH_BROWN: '#4f4f4f',
  BROWN_GREY: '#919191',
};
